import React from "react";
import { ProgressStepper } from "../styles";
import portraitPhoto from "../../assets/images/bharath_2.png";
import { ABOUT_SKILLS } from "../../data/aboutSkills";
import {
  AboutBioBlock,
  AboutContent,
  AboutDualTrack,
  AboutHonorDivider,
  AboutHonorLine,
  AboutHonorsHeading,
  AboutHonorsPanel,
  AboutHonorsSection,
  AboutPageLayout,
  AboutPageRoot,
  AboutPortraitColumn,
  AboutPortraitFrame,
  AboutProse,
  AboutSectionHeading,
  AboutSkillChip,
  AboutSkillLabel,
  AboutSkillsFlex,
  AboutSkillsHeader,
  AboutSkillsSection,
  AboutTimelineWrap,
  AboutTrack,
  AboutTrackHeader,
  AboutTrackTitle,
} from "./aboutStyles";

export default function AboutUs() {
  return (
    <AboutPageRoot className="d-flex flex-column w-100 flex-grow-1">
      <div className="container">
        <AboutPageLayout>
          <AboutPortraitColumn className="animate__animated animate__fadeIn">
            <AboutPortraitFrame>
              <img
                src={portraitPhoto}
                alt="Bharath Chandra Reddy Vadde — portrait"
                width={960}
                height={1200}
                decoding="async"
              />
            </AboutPortraitFrame>
          </AboutPortraitColumn>

          <AboutContent>
            <AboutBioBlock className="animate__animated animate__fadeInUp">
              <AboutSectionHeading>Biography</AboutSectionHeading>
              <AboutProse>
                Hi, I'm Bharath, an XR developer who stumbled into Augmented
                Reality during a 3-credit scientific project in my second
                semester. While others tinkered with theory, I built an AR
                simulation for my professor to showcase a 6-axis robot's
                functionality. That curiosity turned into a passion. Since then,
                I've engineered immersive multi-user XR applications using
                Unity, AR Foundation, and the Mixed Reality Toolkit for
                HoloLens, mobile, and WebGL. Over the years, I’ve optimized,
                debugged, and shipped city guides, simulators, and collaborative
                XR tools with one goal: to make immersive tech feel intuitive. I
                am now excited to push boundaries even further, exploring what's
                next in XR and how we can build smarter and more connected
                realities.
              </AboutProse>
            </AboutBioBlock>

            <AboutDualTrack>
              <AboutTrack className="animate__animated animate__fadeInUp">
                <AboutTrackHeader>
                  <AboutTrackTitle>Education</AboutTrackTitle>
                </AboutTrackHeader>
                <AboutTimelineWrap>
                  <ProgressStepper>
                    <div className="resume">
                      <div className="func">
                        <div className="work">
                          <ul>
                            <li>
                              <span>M.Sc Mechatronics</span>
                              <small>Hochschule Ravensburg-Weingarten</small>
                              <small>Weingarten, Baden Württemberg</small>{" "}
                              <small>Oct 2016 - Feb 2019</small>
                            </li>
                            <li>
                              <span>B.Tech Mechanical Engineering</span>
                              <small>RVR & JC College of engineering</small>
                              <small>Guntur, Andhra Pradesh, India.</small>{" "}
                              <small>Aug 2012 - Apr 2016</small>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </ProgressStepper>
                </AboutTimelineWrap>
              </AboutTrack>

              <AboutTrack className="animate__animated animate__fadeInUp">
                <AboutTrackHeader>
                  <AboutTrackTitle>Experience</AboutTrackTitle>
                </AboutTrackHeader>
                <AboutTimelineWrap>
                  <ProgressStepper>
                    <div className="resume">
                      <div className="func">
                        <div className="work">
                          <ul>
                            <li>
                              <span>
                                Senior Augmented / Mixed reality developer
                              </span>
                              <small>Radiusmedia KG | Bremen</small>
                              <small>07.2019 - 06.2025</small>
                            </li>
                            <li>
                              <span>Master's thesis / Internship</span>
                              <small>UReality, Weingarten</small>
                              <small>11.2017 - 08.2018</small>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </ProgressStepper>
                </AboutTimelineWrap>
              </AboutTrack>
            </AboutDualTrack>

            <AboutSkillsSection className="animate__animated animate__fadeInUp">
              <AboutSkillsHeader>
                <AboutSectionHeading>Skills</AboutSectionHeading>
              </AboutSkillsHeader>
              <AboutSkillsFlex>
                {ABOUT_SKILLS.map((item) => (
                  <AboutSkillChip key={item.id}>
                    <img src={item.src} alt={item.title} />
                    <AboutSkillLabel>{item.title}</AboutSkillLabel>
                  </AboutSkillChip>
                ))}
              </AboutSkillsFlex>
            </AboutSkillsSection>

            <AboutHonorsSection className="animate__animated animate__fadeInUp">
              <AboutHonorsHeading>Honors & Awards</AboutHonorsHeading>
              <AboutHonorsPanel>
                <AboutHonorLine>
                  - Acknowledged by the esteemed Late Dr. APJ Abdul Kalam,
                  former President of India, for my contributions to designing
                  the ATV(All Terrain Vehicle) in 2015
                </AboutHonorLine>
                <AboutHonorDivider />
                <AboutHonorLine>
                  - 'BremerhavenGuide' is nominated for the Tourismuspreis(2022)
                  under the Future Bremerhaven category.
                </AboutHonorLine>
              </AboutHonorsPanel>
            </AboutHonorsSection>
          </AboutContent>
        </AboutPageLayout>
      </div>
    </AboutPageRoot>
  );
}
